import { SvgIcon, SvgIconProps } from '@material-ui/core';

// Séparé de `components/ui/icons/brandIcons.tsx` à l'étape 9c du plan
// « plateforme d'applications », pour rejoindre le module Odoo (étape 9e).

/**
 * Odoo's mark reduced to its « o »: a ring, drawn by hand rather than taken
 * from Simple Icons (the wordmark would be illegible at 1em). Odoo is a
 * trademark of Odoo SA; shown here, in this internal tool, to name the
 * product an environment runs.
 */
export const OdooIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      d="M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 3.75a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5Z"
    />
  </SvgIcon>
);
